import { useTranslation } from 'react-i18next';

import { DotRadio } from '../questions/dotRadio/DotRadio';
import { GadHeaderRow } from '../questions/dotRadio/GadHeaderRow';
import { AssessmentPageItem } from '../types/AssessmentPageItem';

export function MentalHealth4({
  assessmentValues,
  questionid,
  questionHeading,
  questionText,
  regionContent,
  onOpenModal,
  onSetValue,
}: AssessmentPageItem & { regionContent: any }) {
  const { t } = useTranslation();
  const headerText = [
    { key: 0, value: t('radioOption.not_at_all') },
    { key: 1, value: t('radioOption.several_days') },
    { key: 2, value: t('radioOption.more_than_half_the_days') },
    { key: 3, value: t('radioOption.nearly_every_day') },
  ];
  const radioOptions = [
    t('radioOption.not_at_all'),
    t('radioOption.several_days'),
    t('radioOption.more_than_half_the_days'),
    t('radioOption.nearly_every_day'),
  ];

  return (
    <div className="question_container" id={questionid}>
      <h1>{questionHeading}</h1>
      <p>{questionText}</p>

      <fieldset className="question_block_wide gad">
        <legend className="assessment_question_title" id="over_last_2_weeks_4">
          {t('A093')}
        </legend>
        <div className="answer_block">
          <GadHeaderRow headerText={headerText} />
          <DotRadio
            questionid="little_interest"
            range="4"
            width=""
            questionTitle={t('assessment.question.little_interest')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="over_last_2_weeks_4"
          />
          <DotRadio
            questionid="feeling_down"
            range="4"
            width=""
            questionTitle={t('assessment.question.feeling_down')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="over_last_2_weeks_4"
          />
          <DotRadio
            questionid="trouble_falling_asleep"
            range="4"
            width=""
            questionTitle={t('assessment.question.trouble_falling_asleep')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="over_last_2_weeks_4"
          />
          <DotRadio
            questionid="feeling_tired"
            range="4"
            width=""
            questionTitle={t('assessment.question.feeling_tired')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="over_last_2_weeks_4"
          />
          <DotRadio
            questionid="poor_appetite"
            range="4"
            width=""
            questionTitle={t('assessment.question.poor_appetite')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="over_last_2_weeks_4"
          />
          <DotRadio
            questionid="feeling_bad"
            range="4"
            width=""
            questionTitle={t('assessment.question.feeling_bad')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="over_last_2_weeks_4"
          />
          <DotRadio
            questionid="trouble_concentrating"
            range="4"
            width=""
            questionTitle={t('assessment.question.trouble_concentrating')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="over_last_2_weeks_4"
          />
          <DotRadio
            questionid="slow"
            range="4"
            width=""
            questionTitle={t('assessment.question.slow')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            radioOptions={radioOptions}
            outerId="over_last_2_weeks_4"
          />
          <DotRadio
            questionid="self_harm"
            range="4"
            width=""
            questionTitle={t('assessment.question.self_harm')}
            type="gad"
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            onOpenModal={onOpenModal}
            regionContent={regionContent}
            radioOptions={radioOptions}
            outerId="over_last_2_weeks_4"
          />
        </div>
      </fieldset>
    </div>
  );
}
